import { render } from "./SalesmanManagement.vue?vue&type=template&id=844e0128&scoped=true"
import script from "./SalesmanManagement.vue?vue&type=script&lang=js"
export * from "./SalesmanManagement.vue?vue&type=script&lang=js"

import "./SalesmanManagement.vue?vue&type=style&index=0&id=844e0128&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-844e0128"]])

export default __exports__